import { combineReducers } from 'redux';
import { default as list } from 'subaccounts/reducers/subaccounts_list_reducers';
import { default as form } from 'subaccounts/reducers/subaccounts_form_reducers';

export const subaccountsReducers = combineReducers({ list, form });



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/reducers/index.js